export const ERC1155_TRANSFER_SIGNATURE = '0xc3d58168';
export const ERC1155_BATCH_TRANSFER_SIGNATURE = '0x4a39dc06';
export const TRANSFER_SIGNATURES = [
    '0xddf252ad', '0xa9059cbb', '0xf242432a', ERC1155_TRANSFER_SIGNATURE, ERC1155_BATCH_TRANSFER_SIGNATURE,
];
